'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useRef } from 'react';
import { useMountEffect } from '@/hooks/useMountEffect';
import { mountReflow } from '../_lib/reflow';
import { Wordmark } from './Wordmark';
import { EnterLink } from './MuseumTransition';
export function Modern(t0) {
  const $ = _c(21);
  const {
    paragraphs
  } = t0;
  const container = useRef(null);
  const hero = useRef(null);
  const layer = useRef(null);
  const button = useRef(null);
  let t1;
  if ($[0] !== paragraphs) {
    t1 = () => {
      if (!container.current || !hero.current || !layer.current || !button.current) {
        return;
      }
      return mountReflow(container.current, hero.current, layer.current, button.current, paragraphs);
    };
    $[0] = paragraphs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useMountEffect(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h1><Wordmark /></h1>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Image src="/museum/wafer-halftone.png" alt="" width={930} height={930} priority={true} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== paragraphs) {
    t4 = paragraphs.map(_temp);
    $[4] = paragraphs;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <EnterLink />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4) {
    t6 = <div className="museum-mobile-manifesto">{t3}{t4}{t5}</div>;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== paragraphs) {
    t7 = paragraphs.map(_temp2);
    $[9] = paragraphs;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <div className="sr-only">{t7}</div>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="museum-lines" ref={layer} aria-hidden="true" />;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="museum-wafer" ref={hero} aria-hidden="true"><Image src="/museum/wafer-halftone.png" alt="" width={930} height={930} priority={true} /></div>;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="museum-stage">{t9}{t10}<div className="museum-enter-stop" ref={button}><EnterLink /></div></div>;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t8) {
    t12 = <div className="museum-reflow" ref={container}>{t8}{t11}</div>;
    $[16] = t8;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t12 || $[19] !== t6) {
    t13 = <section className="museum-modern">{t2}{t6}{t12}</section>;
    $[18] = t12;
    $[19] = t6;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  return t13;
}
function _temp2(paragraph_0) {
  return <p key={paragraph_0}>{paragraph_0}</p>;
}
function _temp(paragraph) {
  return <p key={paragraph}>{paragraph}</p>;
}